import { render, staticRenderFns } from "./COGMap.vue?vue&type=template&id=b70ae642&"
import script from "./COGMap.vue?vue&type=script&lang=js&"
export * from "./COGMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports